import React, { useState } from 'react'
import MainLayout from '../../layouts/Main'

// import { useGetUserCampuses } from '../../../hooks/campuses';
import { useExportUserSignUpReportForSchool, useGetUserSignUpReportForSchool } from '../../../hooks/analytics';

import LineChart from '../../sub_components/charts/LineChart';
import ReportTablet from '../../sub_components/ReportTablet';
import FilterTable from '../../sub_components/tables/FilterTable';
import ReportDatePicker from '../../sub_components/ReportDatePicker';

import { IColumnProps, IFilterableDataProps } from '../../../interfaces/tables';

import { getDateString } from '../../../helpers/utility';


const UserSignUpReport = () => {
    // let filterTableDataColumns__Campuses: IColumnProps[] = [
    //     { name: "ID", identifier: "id" },
    //     { name: "Campus", identifier: "name" },
    // ];
    let filterTableDataColumns__UserSignUpReport: IColumnProps[] = [
        { name: "ID", identifier: "id" },
        { name: "Full Name", identifier: "full_name" },
        { name: "Email", identifier: "email" },
        { name: "Account Created", identifier: "account_created_at" },
    ];

    // let filterTableData__Campuses: IFilterableDataProps[] = [];
    let filterTableData__UserSignUpReport: IFilterableDataProps[] = [];


    const [campusFilters, setCampusFilters] = useState<number[]>([]); // eslint-disable-line
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");

    const filterQuery = new URLSearchParams();
    filterQuery.set("start_date", startDate);
    filterQuery.set("end_date", endDate);
    campusFilters.forEach((id) => filterQuery.append("campus_ids", id.toString()));

    // const { data: campuses } = useGetUserCampuses();
    const { data: userSignUpReport } = useGetUserSignUpReportForSchool(filterQuery.toString());
    const { mutate: exportUserSignUpReportForSchool } = useExportUserSignUpReportForSchool();

    // if (campuses) {
    //     filterTableData__Campuses = campuses.map((campus) => ({
    //         id: campus.id,
    //         name: campus.name,
    //     }));
    // }

    if (userSignUpReport) {
        filterTableData__UserSignUpReport = userSignUpReport.table_data.map((user) => ({
            id: user.id,
            full_name: user.full_name,
            email: user.email,
            account_created_at: getDateString(user.account_created_at),
        }));
    }

    const onExportCsv = () => {
        exportUserSignUpReportForSchool({
            payload: {
                filterQuery: filterQuery.toString(),
            }
        });
    }

    return (
        <MainLayout>
            <div className='immersion__careers_report'>
                <div className='immersion__careers_report__header'>
                    <div className='immersion__careers_report__header__content'>
                        <h2 className='immersion__careers_report__header__content__title'>User Sign Up Report</h2>
                        <p className='immersion__careers_report__header__content__description'>
                            This slide gives an overview of users who have logged in and had activity on the platform since the start of data collection (20/04/24).
                            The chart to the bottom left shows a cumulative timeline of active users in Immersion (defined as above, having logged into the platform at least once).
                            The table to the bottom right shows the latest date a user has had activity on the platform.
                        </p>
                    </div>
                    <div className='immersion__careers_report__header__actions'>
                        <button className='immersion__btn immersion__btn__primary immersion__careers_report__header__actions__button' onClick={onExportCsv}>Export CSV</button>
                    </div>
                </div>
                <div className='immersion__careers_report__chart_body'>
                    <div className='immersion__careers_report__chart__row'>
                        {/* {campuses?.length
                            ? <FilterTable
                                columns={filterTableDataColumns__Campuses}
                                data={filterTableData__Campuses}
                                filters={campusFilters}
                                setFilters={setCampusFilters}
                                enableFilters={true}
                            />
                            : <div className='immersion__careers_report__chart__no_data'>
                                No campuses found
                            </div>
                        } */}
                        <div className='immersion__careers_report__chart__row immersion__careers_report__chart__row__vertical'>
                            <ReportDatePicker
                                required={true}
                                startDate={startDate}
                                setStartDate={setStartDate}
                                endDate={endDate}
                                setEndDate={setEndDate}
                            />
                            <div className='immersion__careers_report__chart__row'>
                                <ReportTablet
                                    title={userSignUpReport?.accounts_created_in_period?.toString() ?? "0"}
                                    description='Accounts Created in Period'
                                    color={'green'}
                                />
                                <ReportTablet
                                    title={userSignUpReport?.total_accounts_created?.toString() ?? "0"}
                                    description='Total Accounts Created'
                                    color={'green'}
                                />
                                <ReportTablet
                                    title={`${userSignUpReport?.active_user_ratio?.toFixed(1) ?? "0"}%`}
                                    description='Active User Ratio'
                                    color={'green'}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='immersion__careers_report__chart__row'>
                        <FilterTable
                            columns={filterTableDataColumns__UserSignUpReport}
                            data={filterTableData__UserSignUpReport}
                            filters={[]}
                            setFilters={() => { }}
                            enableFilters={false}
                        />
                        {userSignUpReport?.accounts_created_chart_data.length ? (
                            <LineChart
                                data={userSignUpReport?.accounts_created_chart_data ?? []}
                                width={600}
                                height={318}
                                xLabel=""
                                yLabel="Accounts Created"
                            />
                        ) : (
                            <div className='immersion__careers_report__chart__no_data'>
                                No analytics data available
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </MainLayout>
    )
}

export default UserSignUpReport;